import { useCallback, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import api from 'services/api';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import Success from 'components/Snack/Success';
import Error from 'components/Snack/Error';
import { useDispatch, useSelector } from 'react-redux';
import { setDisable } from 'redux/disable';
import { setLoading } from 'redux/loading';
import { schemaProvider } from 'pages/providers/schemas/schema-provider';

export function useProvider() {
  const [swithRegisterBankAccount, setSwithRegisterBankAccount] =
    useState(false);
  const success = Success();
  const error = Error();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const disable = useSelector((state) => state.disable.disable);

  const initialValuesIdentification = {
    name: '',
    street: '',
    number: '',
    uf: '',
    city: '',
    district: '',
    cep: '',
    cpfCnpj: '',
    observation: '',
    nature: '',
  };

  const initialValuesContacts = {
    contacts: [
      {
        representative: '',
        position: '',
        phone_number: '',
        contact_number: '',
        email: '',
      },
    ],
  };

  const initialValuesBankData = {
    bank_information: {
      bank_name: '',
      account_type: '',
      agency: '',
      account_number: '',
      account_digit: '',
      operation: '',
      ownership: '',
      observation: '',
      ownership_nature: '',
      ownership_document: '',
    },
  };

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    dispatch(setLoading(true));
    try {
      if (id) {
        await api.put(`/stakeholders/${id}`, { ...data });
      } else {
        await api.post('/providers', { ...data });
      }
      success();
      history.push('/providers');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  const formik = useFormik({
    initialValues: {
      ...initialValuesIdentification,
      ...initialValuesContacts,
      ...initialValuesBankData,
    },
    validationSchema: schemaProvider(swithRegisterBankAccount),
    // eslint-disable-next-line consistent-return
    onSubmit: (values) => {
      console.log(values);
      console.log(swithRegisterBankAccount);

      if (swithRegisterBankAccount) {
        return request(values);
      }
      const { bank_information, ...rest } = values;
      return request(rest);
    },
  });

  const setData = useCallback((data) => {
    if (data.bank_information) {
      setSwithRegisterBankAccount(true);
    }
    formik.setValues(data);
  }, []);

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
      } else if (location.state.data) {
        setData(location.state.data);
      }
    }
  }, [location, setData]);

  return {
    formik,
    swithRegisterBankAccount,
    setSwithRegisterBankAccount,
    id,
    disable,
    recoverState: location.state,
  };
}
